var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        { staticClass: "akl" },
        [
          _c("div", { staticClass: "bod-view-txt" }, [
            _c(
              "div",
              { staticClass: "os_noticeRes" },
              [
                _c("headers"),
                _vm._v(" "),
                _c("guide"),
                _vm._v(" "),
                _c("terms"),
                _vm._v(" "),
                _c("join", {
                  on: {
                    join: _vm.join,
                    alert: function(type) {
                      return _vm.showLayer(type)
                    }
                  }
                }),
                _vm._v(" "),
                _c("guide_consumer")
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("popuplayer", { attrs: { layers: _vm.layerInfo } })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ed15174", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed15174","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/a7070-glister/index.vue
// module id = null
// module chunks = 